/* eslint-disable */

import Vue from 'vue'
import Router from 'vue-router'
import root from './views/Root.vue'
import bespoke from './views/Bespoke.vue'
import akapp from './views/AKApp.vue'
import faq from './views/FAQ.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'root',
      component: root,
      meta:{
        requireAuth: false,
      },
    },
    {
      path: '/bespoke',
      name: 'bespoke',
      component: bespoke,
      meta:{
        requireAuth: true,
      },
    },
    {
      path: '/app',
      name: 'akapp',
      component: akapp,
      meta:{
        requireAuth: false,
      },
    },
    {
      path: '/faq',
      name: 'faq',
      component: faq,
      meta:{
        requireAuth: false,
      },
    },
    // {
    //   path: '/mview',
    //   name: 'mview',
    //   component: mview,
    //   meta:{
    //     requireAuth: false,
    //   },
    // }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    if (localStorage.getItem("logined") === 'yes') {
      next()
    }
    else {
      if(document.domain.indexOf('anyknew') >= 0){
        window.location = "https://www.anyknew.com"
      }
      else {
        window.location.href = 'http://192.168.4.216:4700/wx/web/login'
        // next()
      }
    }
  }
  else {
    next()
  }
})

export default router